import { render } from "./ViewItemDetails.vue?vue&type=template&id=ffcaa81e&scoped=true"
import script from "./ViewItemDetails.vue?vue&type=script&lang=js"
export * from "./ViewItemDetails.vue?vue&type=script&lang=js"

import "./ViewItemDetails.vue?vue&type=style&index=0&id=ffcaa81e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffcaa81e"]])

export default __exports__